// extracted by mini-css-extract-plugin
export default {"wrapper":"DealerRating-module__wrapper-VEua"};